import SsLogo from "@/assets/icons/ss.svg";
import React from "react";

const Logo = (props: React.ComponentProps<"svg">) => <SsLogo {...props} />;

export default Logo;
